module.exports = __webpack_public_path__ + "static/microsoft-23d2fd7fe58e38140b32f52dfca387e7.png";